import {
  IsBoolean,
  IsDefined,
  IsInt,
  IsISO8601,
  IsNotEmptyObject,
  IsOptional,
  IsString,
  Length,
  Matches, ValidateNested
} from 'class-validator';
import { Type } from 'class-transformer';
import { BillingSubscriptionPriceCreateDto } from '../billing-subscription-price';

export class BillingSubscriptionReplaceDto {
  @IsDefined()
  @IsInt()
  id: number;

  @IsDefined()
  @IsString()
  @Length(0, 150)
  name: string;

  @IsDefined()
  @IsInt()
  billingProductId: number;

  @IsOptional()
  @IsInt()
  sequence?: number;

  @IsOptional()
  @IsBoolean()
  isActive?: boolean;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  currentDay: string;

  @IsOptional()
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => BillingSubscriptionPriceCreateDto)
  effectivePrice?: BillingSubscriptionPriceCreateDto
}